export const SET_CURRENT = 'SET_CURRENT';
export const CLEAR_CURRENT = 'CLEAR_CURRENT';
export const CLEAR_FILTER = 'CLEAR_FILTER';
export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const USER_LOADED = 'USER_LOADED';
export const AUTH_ERROR = 'AUTH_ERROR';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';
export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const GET_USER = 'GET_USER';
export const GET_USERS = 'GET_USERS';
export const GET_CLIENTRDS = 'GET_CLIENTRDS';
export const ADD_CLIENTRD = 'ADD_CLIENTRD';
export const DELETE_CLIENTRD = 'DELETE_CLIENTRD';

export const UPDATE_CLIENTRD = ' UPDATE_CLIENTRD';
export const FILTER_CLIENTRDS = 'FILTER_CLIENTRDS';

export const CLIENTRD_ERROR = 'CLIENTRD_ERROR';
export const CLEAR_CLIENTRDS = 'CLEAR_CLIENTRDS';
